import { HEADER_AGENT_CODE_REFERENCE } from 'constants';
import { CURRENCY_NAME_REFERENCE } from 'constants/currency';
import { isEmpty } from 'lodash';
import { SET_REMITTANCE_RATES_SELECTED } from 'store/action';
import { getPathExchangRate } from './useFirebase';
import useRetriveDatabaseInstance from './useRetriveDatabaseInstance';
import useTheme from './useTheme';

const useExchangeRatesSelected = () => {
  const { theme } = useTheme();

  const agentCode = HEADER_AGENT_CODE_REFERENCE[theme];

  const { retriveDataFromRealtimeDatabase, closeRealtimeDatabaseConnection } =
    useRetriveDatabaseInstance({
      databaseURL: process.env.REACT_APP_FIREBASE_EXCHANGE_RATE_DATABASE_URL,
      actionName: SET_REMITTANCE_RATES_SELECTED,
      isDisable: true,
      storeOptions: {
        isAppendToObject: true,
      },
      queryOptions: {
        isQuery: true,
        limitToLast: 1,
      },
    });

  const getRemittanceRatesSelected = (country) => {
    if (isEmpty(country)) return null;
    const { code: countryCode, currencies } = country || {};
    if (isEmpty(currencies)) return null;
    const result = {};
    result[countryCode] = {};
    currencies.forEach((currencyCode) => {
      result[countryCode][currencyCode] = {}; // Initialize as an empty object
    });
    currencies.forEach((currencyCode) => {
      retriveDataFromRealtimeDatabase({
        path: getPathExchangRate(currencyCode, agentCode),
        prop: currencyCode,
        callback: (exchangeRate) => {
          const createdAt = exchangeRate ? Object.keys(exchangeRate)?.[0] : 0;
          const currencyWithAgentCode = exchangeRate?.[createdAt]?.[agentCode];
          const currencyWithGlobal = exchangeRate?.[createdAt]?.['GLOBAL'];

          const exchangeRateData = {
            currency: {
              name: CURRENCY_NAME_REFERENCE?.[currencyCode],
              code: currencyCode,
            },
            currencyCode,
            rate: currencyWithAgentCode || currencyWithGlobal || 0,
            createdAt,
          };
          result[countryCode][currencyCode] = exchangeRateData;
        },
      });
    });
    return result;
  };

  const closeRemittanceRatesSelected = (country) => {
    if (isEmpty(country)) return null;
    const { currencies = ['EUR', 'KRW'] } = country || {};
    if (isEmpty(currencies)) return null;
    currencies.forEach((currencyCode) => {
      closeRealtimeDatabaseConnection({
        path: getPathExchangRate(currencyCode, agentCode),
      });
    });
  };

  return { getRemittanceRatesSelected, closeRemittanceRatesSelected };
};

export default useExchangeRatesSelected;
